import Image from "next/image";

const logos = [
  { src: "/logos/air-force.svg", alt: "U.S. Air Force", w: 170, h: 23 },
  {
    src: "/logos/dept-of-war.svg",
    alt: "U.S. Department of War",
    w: 133,
    h: 28,
  },
  {
    src: "/logos/va.svg",
    alt: "U.S. Department of Veterans Affairs",
    w: 127,
    h: 28,
  },
  { src: "/logos/palantir.svg", alt: "Palantir", w: 86, h: 21 },
  { src: "/logos/nvidia.svg", alt: "NVIDIA", w: 117, h: 22 },
];

export function Logos() {
  return (
    <div className="flex items-center justify-end w-full gap-x-4 xl:gap-x-6 2xl:gap-x-10">
      {logos.map((logo) => (
        <div
          key={logo.alt}
          className="flex items-center justify-center min-w-0"
          style={{
            width: logo.w,
            aspectRatio: `${logo.w} / ${logo.h}`,
          }}
        >
          <Image
            src={logo.src}
            alt={logo.alt}
            width={logo.w}
            height={logo.h}
            className="w-full h-auto object-contain"
          />
        </div>
      ))}
    </div>
  );
}
